// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"466":"e764061b","488":"0e1e2984","584":"20b7d131","585":"61d9139a","648":"98d094d2","735":"a8ac2f1c"}[chunkId] + ".chunk.js";
};